import dashTypes from "./dash.types";

export default {
  [dashTypes.FETCH_ANALYTICS_REQUEST](state) {
    state.type = dashTypes.FETCH_ANALYTICS_REQUEST;
    state.error = "";
  },
  [dashTypes.FETCH_ANALYTICS_SUCCESS](state, payload) {
    state.type = dashTypes.FETCH_ANALYTICS_SUCCESS;
    state.data = { ...state.data, ...payload.data };
  },
  [dashTypes.FETCH_ANALYTICS_FAILED](state, payload) {
    state.type = dashTypes.FETCH_ANALYTICS_FAILED;
    state.error = payload.error;
  },


  [dashTypes.FETCH_DASHBOARDVIDEO_REQUEST](state, payload) {
    state.type = dashTypes.FETCH_DASHBOARDVIDEO_REQUEST;
    state.error = "";
  },
  [dashTypes.FETCH_DASHBOARDVIDEO_SUCCESS](state, payload) {
    state.type = dashTypes.FETCH_DASHBOARDVIDEO_SUCCESS;
    state.fetchData = payload.fetchData;
  },
  [dashTypes.FETCH_DASHBOARDVIDEO_FAILED](state, payload) {
    state.type = dashTypes.FETCH_DASHBOARDVIDEO_FAILED;
    state.error = payload.error;
  },
  [dashTypes.FETCH_NAME_SUCCESS](state, payload) {
    state.type = dashTypes.FETCH_NAME_SUCCESS;
    state.data = payload.nameData;
  },

  [dashTypes.DELETE_VIDEO_REQUEST](state, payload) {
    state.type = dashTypes.DELETE_VIDEO_REQUEST;
    state.error = "";
  },
  [dashTypes.DELETE_VIDEO_FAILED](state, payload) {
    state.type = dashTypes.DELETE_VIDEO_FAILED;
    state.error = payload.error;
  },
  [dashTypes.DELETE_VIDEO_SUCCESS](state, payload) {
    state.type = dashTypes.DELETE_VIDEO_SUCCESS;
    state.data = payload.data;
  },

 [dashTypes.FETCH_PENDINGDVIDEO_REQUEST](state, payload) {
    state.type = dashTypes.FETCH_PENDINGDVIDEO_REQUEST;
    state.error = "";
  },
  [dashTypes.FETCH_PENDINGDVIDEO_SUCCESS](state, payload) {
    state.type = dashTypes.FETCH_PENDINGDVIDEO_SUCCESS;
    state.fetchPendingData = payload.fetchPendingData;
  },
  [dashTypes.FETCH_PENDINGDVIDEO_FAILED](state, payload) {
    state.type = dashTypes.FETCH_PENDINGDVIDEO_FAILED;
    state.error = payload.error;
  },

  [dashTypes.APPROVAL_VIDEO_REQUEST](state, payload) {
    state.type = dashTypes.APPROVAL_VIDEO_REQUEST;
    state.error = "";
  },
  [dashTypes.APPROVAL_VIDEO_SUCCESS](state, payload) {
    state.type = dashTypes.APPROVAL_VIDEO_SUCCESS;
    state.fetchPendingData = payload.fetchPendingData;
  },
  [dashTypes.APPROVAL_VIDEO_FAILED](state, payload) {
    state.type = dashTypes.APPROVAL_VIDEO_FAILED;
    state.error = payload.error;
  },

  
  [dashTypes.FETCH_VIDEOLIBRARY_REQUEST](state, payload) {
    state.type = dashTypes.FETCH_VIDEOLIBRARY_REQUEST;
    state.error = "";
  },
  [dashTypes.FETCH_VIDEOLIBRARY_SUCCESS](state, payload) {
    state.type = dashTypes.FETCH_VIDEOLIBRARY_SUCCESS;
    state.fetchlibraryData = payload.fetchlibraryData;
  },
  [dashTypes.FETCH_VIDEOLIBRARY__FAILED](state, payload) {
    state.type = dashTypes.FETCH_VIDEOLIBRARY__FAILED;
    state.error = payload.error;
  },


  [dashTypes.FETCH_WEEKLY_REQUEST](state, payload) {
    state.type = dashTypes.FETCH_WEEKLY_REQUEST;
    state.error = "";
  },
  [dashTypes.FETCH_WEEKLY_SUCCESS](state, payload) {
    state.type = dashTypes.FETCH_WEEKLY_SUCCESS;
    state.weekly = payload.weekly;
  },
  [dashTypes.FETCH_WEEKLY__FAILED](state, payload) {
    state.type = dashTypes.FETCH_WEEKLY__FAILED;
    state.error = payload.error;
  },

  [dashTypes.SendLibraryVideo_Request](state, payload) {
    state.type = dashTypes.SendLibraryVideo_Request;
    state.error = "";
  },
  [dashTypes.SendLibraryVideo_Sucess](state, payload) {
    state.type = dashTypes.SendLibraryVideo_Sucess;
    // state.weekly = payload.weekly;
  },
  [dashTypes.SendLibraryVideo__FAILED](state, payload) {
    state.type = dashTypes.SendLibraryVideo__FAILED;
    state.error = payload.error;
  },
};
